module.exports = __webpack_public_path__ + "media/recipes/133-cc5f9027.png";